import { createRequest } from "./createRequest"

export const GetTagsRequest = createRequest({
  type: "getTags",
  run(client, options) {
    return client.getTags(options)
  },
})
